import Cookies from 'js-cookie';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LicenseInformation } from './System/LicenseInformation';
import { ColorContext } from 'App';
import { clearCookies } from 'utils/cookieUtils';
import { Alert, Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import {
  activate_activateAccount,
  activate_checkVerification,
  activate_setPassword,
} from 'services/account/account.service';

export default function ActivateAccount({ setCookiesAgreed, setPrivacyAgreed }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  //eslint-disable-next-line no-unused-vars
  const [initPassword, setInitPassword] = useState(null);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [check, setCheck] = useState(true);
  const [error, setError] = useState('');
  const [currentScreen, setCurrentScreen] = useState('password');
  const [licenseSuccess, setLicenseSuccess] = useState(false);

  const code = searchParams.get('code');
  const theme = useContext(ColorContext);

  useEffect(() => {
    (async () => {
      clearCookies();
      let verified;
      await activate_checkVerification(code)
        .then((res) => {
          verified = res.data.message;
          setInitPassword(res.data.password);
        })
        .catch(() => {
          verified = 'User already validated';
        });

      if (verified === 'User already validated') {
        goToLogin();
      }
    })();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  const onSubmit = async () => {
    setCheck(password && password === confirmPassword);

    if (password === confirmPassword) {
      const verificationCode = searchParams.get('code');
      await activate_setPassword(verificationCode, password)
        .then((res) => {
          if (res.status === 200) {
            setInitPassword(false);
            onActivate();
          } else {
            setError('Something went wrong');
          }
        })
        .catch((e) => {
          setError(e.message);
        });
    }
  };

  const onActivate = async () => {
    const activationCode = searchParams.get('code');
    await activate_activateAccount(activationCode)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.accessLevel === undefined) return;

          if (res.data.accessLevel === 13) {
            setCurrentScreen('license');
          } else {
            setCurrentScreen('skipLicense');
          }
        } else {
          setError('Something went wrong');
        }
      })
      .catch((e) => {
        setError(e.message);
      });
  };

  const onLicenseSubmit = () => {
    setLicenseSuccess(true);
  };

  const goToLogin = async () => {
    Cookies.remove('accessToken');
    Cookies.remove('refreshToken');
    if (Cookies.get('rememberMe') === 'false') Cookies.remove('email');

    setCookiesAgreed(true);
    setPrivacyAgreed(true);
    navigate('/');
  };

  const renderPasswordScreen = () => (
    <Card className="bg-transparent border-0" style={{ color: theme.fontColor }}>
      <Card.Body className="d-flex flex-column gap-3">
        <div className="fw-bold fs-4">Set Your Password</div>
        <Form>
          <Form.Group className="mb-3" controlId="password">
            <Form.Label className={!check && !password ? 'text-danger' : ''}>
              Password
              {!check && !password && (
                <span className="ms-2 text-danger">* Must enter password</span>
              )}
            </Form.Label>
            <Form.Control
              type="password"
              value={password || ''}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-dark text-white border-secondary"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label className={!check ? 'text-danger' : ''}>
              Confirm Password
              {!check && <span className="ms-2 text-danger">* Must match password</span>}
            </Form.Label>
            <Form.Control
              type="password"
              value={confirmPassword || ''}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="bg-dark text-white border-secondary"
            />
          </Form.Group>

          <Button variant="primary" onClick={onSubmit}>
            Set Password
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );

  const renderLicenseScreen = () => (
    <Card className="bg-transparent border-0" style={{ color: theme.fontColor }}>
      <Card.Body className="d-flex flex-column gap-3">
        {!licenseSuccess ? (
          <LicenseInformation inline activationCode={code} callback={onLicenseSubmit} />
        ) : (
          <>
            <div className="fw-bold fs-5">License Activation Successful!</div>
            <Button variant="primary" className="align-self-start" onClick={goToLogin}>
              Login
            </Button>
          </>
        )}
      </Card.Body>
    </Card>
  );

  const renderSkipLicense = () => (
    <Card className="bg-transparent border-0" style={{ color: theme.fontColor }}>
      <Card.Body className="d-flex flex-column gap-3">
        <div className="fw-bold fs-5">Activation Successful!</div>
        <Button variant="primary" className="align-self-start" onClick={goToLogin}>
          Login
        </Button>
      </Card.Body>
    </Card>
  );

  return (
    <Container fluid className="py-4">
      <Row className="justify-content-center">
        <Col xs={12} md={8} lg={5} className="d-flex flex-column gap-4">
          {currentScreen === 'password' && renderPasswordScreen()}
          {currentScreen === 'license' && renderLicenseScreen()}
          {currentScreen === 'skipLicense' && renderSkipLicense()}

          {error && (
            <Alert variant="danger" className="mb-0">
              Error: {error}
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
}
